export default "__VITE_ASSET__Cl4adArq__"